import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface PaymentMethod {
  id: number;
  name: string;
}

const fetchPaymentMethods = async (): Promise<PaymentMethod[]> => {
  try {
    const { data } = await api.get<PaymentMethod[]>('/api/payment-methods');
    return data;
  } catch (error) {
    console.error('Error en fetchPaymentMethods:', error);
    if (error instanceof Error) {
      throw new Error(`Error al cargar los métodos de pago: ${error.message}`);
    }
    throw new Error('Error desconocido al cargar los métodos de pago');
  }
};

export const usePaymentMethods = () => {
  const { 
    data: paymentMethods = [], 
    isLoading, 
    error,
    isError 
  } = useQuery({
    queryKey: ['payment-methods'],
    queryFn: fetchPaymentMethods,
    retry: 1,
    refetchOnWindowFocus: false
  });

  return {
    paymentMethods,
    isLoading,
    error: isError ? (error instanceof Error ? error.message : 'Error desconocido al cargar los métodos de pago') : null
  };
}; 